import type { EscalationStage } from "@remi/enums/escalation-stage";

const BACKWARD_TRANSITIONS: [EscalationStage, EscalationStage][] = [
  ["PENDING_CONTACT", "NOT_CONTACTED"],
  ["PENDING_RESOLUTION", "NOT_CONTACTED"],
  ["RESOLVED_PENDING_COMPLETION", "PENDING_RESOLUTION"],
  ["RESOLVED_PENDING_COMPLETION", "NOT_CONTACTED"],
  ["COMPLETION", "PENDING_RESOLUTION"],
  ["DISMISSED", "PENDING_RESOLUTION"],
];

export function isBackwardTransition(from: EscalationStage, to: EscalationStage): boolean {
  return BACKWARD_TRANSITIONS.some(([f, t]) => f === from && t === to);
}

export function isTerminalStage(stage: EscalationStage): boolean {
  return stage === "COMPLETION" || stage === "DISMISSED";
}

export type EscalationSnoozeRejection = "NOT_IN_FUTURE" | "ESCALATION_CLOSED";

export function getSnoozeRejection(input: {
  snoozedUntil: Date;
  stage: EscalationStage;
  now: Date;
}): EscalationSnoozeRejection | null {
  if (input.snoozedUntil <= input.now) {
    return "NOT_IN_FUTURE";
  }
  if (isTerminalStage(input.stage)) {
    return "ESCALATION_CLOSED";
  }
  return null;
}
